import React from "react";
import { Link } from "react-router-dom";
import { Search, Building2, KeyRound } from "lucide-react";

export default function VisitorDashboard() {
  return (
    <div className="bg-surface border border-neutral-200 shadow-card rounded-2xl p-10 text-center" data-testid="visitor-dashboard">
      <h2 className="text-2xl font-bold text-neutral-900 mb-2">You're browsing as a Visitor</h2>
      <p className="text-neutral-500 max-w-md mx-auto mb-6">
        Explore listings across Pune. Want to list a property or save requirements?
        Register a dedicated account to unlock more.
      </p>
      <div className="flex flex-wrap gap-3 justify-center">
        <Link to="/properties" className="flex items-center gap-2 px-6 py-3 font-semibold text-white bg-gradient-to-r from-brand-500 to-brand-600 rounded-xl">
          <Search className="w-5 h-5" /> Search Properties
        </Link>
        <Link to="/properties?listing_type=Buy" className="flex items-center gap-2 px-6 py-3 border border-neutral-300 rounded-xl text-neutral-700 hover:text-neutral-900">
          <Building2 className="w-5 h-5" /> Buy
        </Link>
        <Link to="/properties?listing_type=Rent" className="flex items-center gap-2 px-6 py-3 border border-neutral-300 rounded-xl text-neutral-700 hover:text-neutral-900">
          <KeyRound className="w-5 h-5" /> Rent
        </Link>
      </div>
    </div>
  );
}
